import { render, staticRenderFns } from "./DesignsUploaded.vue?vue&type=template&id=ea0196de"
import script from "./DesignsUploaded.vue?vue&type=script&lang=js"
export * from "./DesignsUploaded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports